import React from "react";

import { SelectEntityByType } from "../../modules/SelectEntityByType/SelectEntityByType";
import { FiltersFieldsTypes } from "../../modules/SelectEntityByType/constants";

export const DataSelectorConditionTypeField = ({
    className,
    name = "condition_type_code",
    label = "Selector Condition",
    ...restProps
}) => (
    <SelectEntityByType
        className={className}
        name={name}
        FieldsTypes={FiltersFieldsTypes.dataSelectorConditionType}
        label={label}
        isRequired
        {...restProps}
    />
);
